module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NjgiIGhlaWdodD0iNDg3IiB2aWV3Qm94PSIwIDAgNzY4IDQ4NyI+CiAgPGcgb3BhY2l0eT0iMC4zIj4KICAgIDxwYXRoIGZpbGw9IiNEQjFGNDMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTS0yMS4zOTMtMTEuMzUyYzI1Mi4wMTUgMTQzLjY3MiA1NjAuOTk0IDE0My42NzIgOTI2LjkzNiAwIDM2NS45NDMtMTQzLjY3MiAzNjUuOTQzIDI0LjQ3NSAwIDUwNC40NDItMzMwLjQ4Mi04OC41NTEtNjM5LjQ2LTg4LjU1MS05MjYuOTM2IDBzLTI4Ny40NzYtNzkuNTk2IDAtNTA0LjQ0MnoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/img/participation-bg-shape@tl.svg
// module id = wql2
// module chunks = 0